// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3LkCz","title":"FrontImage_title__5e8ai"};